<template>
    <b-container fluid style="padding:10px">
        <b-jumbotron header="Projects">
            Random Data Sciencey projects that I've done - Note: redirects to another site because I can't figure it out in Vue :(
        </b-jumbotron>
        <b-row align-content center>
                <b-card
                        title="High Level Overview"
                        img-src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=300&q=80"
                        img-alt="Image"
                        img-top
                        tag="article"
                        class="mb-2 project mx-auto"
                >
                    <b-card-text>
                        High level overview of business metrics and growth. Used R and SQL for a Video Sharing company.
                    </b-card-text>

                    <b-button href="https://kmok.org/high-level" variant="primary">See Report</b-button>
                </b-card>
                <b-card
                        title="Predicting Churn"
                        img-src="https://images.unsplash.com/photo-1530041686259-53d26f863313?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=300&q=80"
                        img-alt="Image"
                        img-top
                        tag="article"
                        class="mb-2 project mx-auto"
                >
                    <b-card-text>
                        Built Logistic Regression to predict customer churn. Used SQL and R for a Fitness VOD company.
                    </b-card-text>

                    <b-button href="https://kmok.org/churn" variant="primary">See Report</b-button>
                </b-card>
                <b-card
                        title="Segmentation"
                        img-src="https://images.unsplash.com/photo-1529699211952-734e80c4d42b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=300&q=80"
                        img-alt="Image"
                        img-top
                        tag="article"
                        class="mb-2 project mx-auto"
                >
                    <b-card-text>
                        Segmented customers using adapted RFM model.
                        Used R, Google Sheets, MixPanel data for a classes on demand company.
                    </b-card-text>

                    <b-button href="https://kmok.org/rfm" variant="primary">See Report</b-button>
                </b-card>
            <b-card
                    title="Startups"
                    img-src="https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=300&q=80"
                    img-alt="Image"
                    img-top
                    tag="article"
                    class="mb-2 project mx-auto"
            >
                <b-card-text>
                    Tried to predict if a company would IPO with Crunchbase Data as an interview exercise.
                    Used Python and Logistic Regression
                </b-card-text>

                <b-button href="https://kmok.org/crunchbase" variant="primary">See Report</b-button>
            </b-card>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: "Projects"
    }
</script>

<style scoped>
.project {
    margin:10px;
    max-width: 18rem;
}
</style>